module.exports = __webpack_public_path__ + "img/myReserve.8efab952.png";